import { Component, OnChanges, AfterContentInit, Input, ContentChildren, QueryList, SimpleChanges } from '@angular/core';
import { encapsulation } from '../encapsulation';
import { UBXAccordionRowComponent } from './row/accordion-row.component';

@Component({
    selector: 'ubx-accordion',
    templateUrl: './accordion.component.html',
    host: { class: 'ubx-accordion flx f-fd:c' },
    encapsulation
})
export class UBXAccordionComponent implements OnChanges, AfterContentInit {
    @Input() expand: Array<number>;
    @Input() multi = false;
    @Input() disable: Array<number>;

    @ContentChildren(UBXAccordionRowComponent) rows: QueryList<UBXAccordionRowComponent>;

    ngAfterContentInit() {
        this.expandRows(this.expand);
        this.disableRows(this.disable);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.open && changes.open.previousValue) {
            this.expandRows(changes.open.currentValue);
        }
        if (changes.disable && changes.disable.previousValue) {
            this.disableRows(changes.disable.currentValue);
        }
    }

    closeAllRows() {
        this.rows.forEach((row: UBXAccordionRowComponent) => {
            row.toggleRow(false);
        });
    }

    private expandRows(expand: Array<number>) {
        if (expand) {
            this.executeRow(expand, 'toggleRow');
        }
    }
    private disableRows(disable: Array<number>) {
        if (disable) {
            this.executeRow(disable, 'disableRow');
        }
    }

    private executeRow(attr: Array<number>, func: string) {
        this.rows.toArray().find((row, i) => attr.indexOf(i) !== -1  && row[func](true));
    }
}
